import React from 'react';
import { TeamKnowledgeCard } from '../../../../knowledge-cards/team-knowledge-card';
import { useAIAnswerContext } from '../../../ai-answer-context';
import { NLPSearchJSONResultFormat } from '../../../types';
import { getTypedJSONResultDataAssistanceService } from '../../../utils/getTypedJSONResultData';
import { AIAnswerWhoResult } from './who-result';
import { AIAnswerWorkResult } from './work-result';
export var JsonResultComponent = function JsonResultComponent() {
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes;
  var answerString = commonAttributes.answerString;
  var _getTypedJSONResultDa = getTypedJSONResultDataAssistanceService(answerString),
    parsedType = _getTypedJSONResultDa.parsedType;
  switch (parsedType) {
    case NLPSearchJSONResultFormat.WHO:
      return /*#__PURE__*/React.createElement(AIAnswerWhoResult, null);
    case NLPSearchJSONResultFormat.WORK:
      return /*#__PURE__*/React.createElement(AIAnswerWorkResult, null);
    case NLPSearchJSONResultFormat.TEAM:
      return /*#__PURE__*/React.createElement(TeamKnowledgeCard, null);
    default:
      return null;
  }
};